import React, { Component } from 'react'
import ReactDisqusComments from 'react-disqus-comments'
import Feedback from '../../images/feedback.svg'
class Disqus extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    if (!this.props.shortname) {
      return null
    }
    return (
      <div className="disqus-wrapper">
        <div className="title-wrapper">
          <img src={Feedback} alt="feedback phanorcoll.com" />
          <div className="title">comments</div>
        </div>
        <ReactDisqusComments
          shortname={this.props.shortname}
          identifier={this.props.identifier}
          title={this.props.title}
          url={this.props.url}
        />
      </div>
    )
  }
}

export default Disqus



// WEBPACK FOOTER //
// ./src/components/Disqus/Disqus.jsx